import { render } from "./PedigreeNew.vue?vue&type=template&id=8405f58c&scoped=true"
import script from "./PedigreeNew.vue?vue&type=script&lang=js"
export * from "./PedigreeNew.vue?vue&type=script&lang=js"

import "./PedigreeNew.vue?vue&type=style&index=0&id=8405f58c&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8405f58c"]])

export default __exports__